export default __webpack_public_path__ + "aa0c91d1cdc63a6a51e844782f57fd0c.png";